import { Attrs, EventListeners, MinzeElement } from 'minze'
import { Locale } from '../../modules/locale'
import { EventItem } from './lvc-artist-events'

Locale.getInstance().registerKeySet('fr', 'artistEventOffers', {
  exhibitionsTitle: 'Exposition',
  eventSeriesTitle: 'Série',
  eventsTitle: 'Dates',
})

Locale.getInstance().registerKeySet('en', 'artistEventOffers', {
  exhibitionsTitle: 'Exhibition',
  eventSeriesTitle: 'Serie',
  eventsTitle: 'Dates',
})

export interface LvcArtistEventOffers {
  loading: boolean
  items: EventItem[]
}
export class LvcArtistEventOffers extends MinzeElement {
  attrs: Attrs = ['loading']
  static observedAttributes = ['loading']

  setItems = (event: Event) => {
    const detail = (event as CustomEvent).detail
    this.items = detail.offers as EventItem[]
    this.rerender(true)
  }

  getTitle = (schema: any) => {
    switch (schema) {
      case 'exhibitionEvents':
        return Locale.getKey('artistEventOffers.exhibitionsTitle')
      case 'eventSeries':
        return Locale.getKey('artistEventOffers.eventSeriesTitle')
      default:
        return Locale.getKey('artistEventOffers.eventsTitle')
    }
  }

  html = () => {
    if (this.loading) return ''
    return /*html*/ `
      <div id="offers-container">
        <div class="title-wrapper">
          <h3 class="title">
            ${this.getTitle(this.items?.[0]?.schema)}
          </h3>
          <div class="counter">
            ${this.items.length}
          </div>
        </div>
        <lvc-search-result-block data-component-location="programmation_artiste" results="${encodeURIComponent(JSON.stringify(this.items))}" enable-date-blocks="false"></lvc-search-result-block>
      </div>
    `
  }

  css = () => `
    :host {
      margin-top: 2rem;
    }
    lvc-search-result-block {
      margin-top: 1rem;
      border-top: 1px solid rgba(30,0,125, 0.3);
    }
    .title-wrapper {
      display: flex;
      color: #1E007D;
    }
    .counter {
      margin-left: 5px;
      margin-top: -8px;
    }
    .title {
      margin: 0;
      font-size: 24px;
      font-weight: 800;
      line-height: 1.1
    }
    lvc-event-card {
      transition: all 0.2s;
    }
    lvc-event-card:hover {
      background: rgba(30, 0, 125, 0.05);
      padding: 0 2rem;
    }
    lvc-event-card:not(:first-child) {
      border-top: 1px solid rgba(30, 0, 125, 0.3);
    }
  `

  eventListeners: EventListeners = [
    [window, 'lvc:artist-spectacles-event-offers-loaded', this.setItems],
  ]
}
